import styled from '@emotion/styled';

export const Container = styled.section`
  width: 890px;
  height: 640px;
  box-sizing: border-box;
  transition: all ease 1s 0s;
  font-family: Pretendard;
  margin: auto 0;
`;

export const GuideArea = styled.div`
  letter-spacing: 0;
  text-align: center;
  color: #ffffff;
  font-family: Pretendard;
`;

export const GuideTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
`;

export const GuideHint = styled.p`
  margin: 14px 0;
  font-size: 18px;
`;
